var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import * as React from "react";
import { IdStyles } from "../../../less/IdStyles";
import { BaseButton } from "../base-button/BaseButton";
import { IdButtonType } from "../base-button/IdButtonType";
export var ButtonSecondaryMedium = React.memo(function (props) { return (React.createElement(BaseButton, __assign({ name: IdStyles.ButtonPrimaryAccent, styleId: IdButtonType.ButtonRectangleLarge }, props))); });



//////////////////
// WEBPACK FOOTER
// ./src/features/generic/common/ButtonSecondaryMedium.tsx
// module id = 301
// module chunks = 3